import { Component, Input, OnInit } from '@angular/core';
import { FreeEvaluationType } from 'src/app/shared/components/free-evaluation-users-list/interfaces/free-evaluation-type';
import { ModalController, ToastController } from '@ionic/angular';
import { TranslationService } from 'src/app/shared/services/translation.service';
import { ButtonOptions } from 'src/app/shared/modals/text-alert/interfaces/text-alert.interface';

@Component({
    selector: 'app-text-alert-modal',
    templateUrl: './text-alert-modal.component.html',
    styleUrls: ['./text-alert-modal.component.scss'],
})
export class TextAlertModal implements OnInit {

    @Input() evaluationType: FreeEvaluationType;
    @Input() closeButtonHeader: boolean = true;
    @Input() headerText: string = null;
    @Input() contentText: string = null;
    @Input() leftOption: ButtonOptions = null;
    @Input() rightOption: ButtonOptions = null;

    constructor(
            protected _toastController: ToastController,
            protected _translationService: TranslationService,
            private _modalController: ModalController,
    ) {
    }

    ngOnInit() {
    }

    public async dismiss(signal: boolean = false) {
        await this._modalController.dismiss(signal);
    }
}
